import { render, staticRenderFns } from "./TabsHead.vue?vue&type=template&id=85618332&scoped=true"
import script from "./TabsHead.vue?vue&type=script&lang=js"
export * from "./TabsHead.vue?vue&type=script&lang=js"
import style0 from "./TabsHead.vue?vue&type=style&index=0&id=85618332&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85618332",
  null
  
)

export default component.exports